/*
 * Voorraadmelding — houdt het blok in sync met de gekozen lengte.
 *
 * Dawn ververst bij een variantwissel alleen prijs, knop en een paar vaste regio's
 * (product-info.js). Dit blok zit daar niet bij, dus zonder dit script blijft de tag op de
 * eerst gekozen lengte staan en meldt iemand zich voor de verkeerde maat aan.
 * Zelfde patroon als price-per-item.js: abonneren op PUB_SUB_EVENTS.variantChange.
 */
(function () {
  function lengteTag(title) {
    return String(title || '')
      .replace(/cm/gi, '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function fill(template, lengte, datum) {
    return String(template || '').split('[lengte]').join(lengte).split('[datum]').join(datum);
  }

  function update(block, variant) {
    if (!variant) return;

    block.hidden = variant.available === true;

    var datum = block.dataset.date;
    var expected = block.querySelector('[data-ground-restock-expected]');
    var intro = block.querySelector('[data-ground-restock-intro]');
    var tags = block.querySelector('[data-ground-restock-tags]');

    if (expected) expected.textContent = fill(block.dataset.templateExpected, variant.title, datum);
    if (intro) intro.textContent = fill(block.dataset.templateIntro, variant.title, datum);
    if (tags) tags.value = 'wachtlijst,wachtlijst-' + lengteTag(variant.title);
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data) return;
      document
        .querySelectorAll('[data-ground-restock][data-section-id="' + data.sectionId + '"]')
        .forEach(function (block) {
          update(block, data.variant);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
